var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.hideInput)?_c('Input',{attrs:{"placeholder":_vm.placeholder,"clearable":""},on:{"on-change":_vm.makeCode},model:{value:(_vm.qrcodeText),callback:function ($$v) {_vm.qrcodeText=$$v},expression:"qrcodeText"}}):_vm._e(),_vm._v(" "),_c('div',{ref:"qrcode"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72647801","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/qrcode.vue
// module id = null
// module chunks = 